// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__FnDqT","icon":"Contact_icon__CNDt8","buttons":"Contact_buttons__TjKTN","linkedin":"Contact_linkedin__8YTnu","resume":"Contact_resume__t1j67"};